module.exports = __webpack_public_path__ + "static/img/fa-solid-900.6c36adf.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-solid-900.svg
// module id = 344
// module chunks = 1